import React from "react"
import { useTranslation } from "react-i18next"
import ReactMarkdown from "react-markdown"

interface StreamingChatBubbleProps {
  message: string
  isUser: boolean
  timestamp: string
  isStreaming?: boolean
  showTypingIndicator?: boolean
}

export const StreamingChatBubble: React.FC<StreamingChatBubbleProps> = ({
  message,
  isUser,
  timestamp,
  isStreaming = false,
  showTypingIndicator = false,
}) => {
  const { t } = useTranslation()

  return (
    <div
      className={`relative my-2 w-[85%] break-words rounded-2xl px-4 py-3 pt-4 text-body-xs duration-200 animate-in slide-in-from-bottom-2 ${
        isUser
          ? "ml-auto rounded-br-none bg-brown-500 text-white"
          : "mr-auto rounded-bl-none border border-neutral-400 bg-white text-neutral-700"
      } `}
    >
      <div className="mb-1">
        {isUser ? (
          message
        ) : (
          <>
            <ReactMarkdown className="prose prose-sm max-w-none leading-relaxed">
              {message}
            </ReactMarkdown>
            {(isStreaming || showTypingIndicator) && (
              <span className="animate-pulse ml-1 font-bold text-neutral-500">
                ▋
              </span>
            )}
          </>
        )}
      </div>
      <div className="mt-1 text-xs opacity-70">{timestamp}</div>
      {isStreaming && (
        <div className="absolute -right-2 -top-2 flex items-center gap-1 rounded-full bg-green-500 px-2 py-1 text-xs text-white">
          <div className="animate-pulse h-1.5 w-1.5 rounded-full bg-white"></div>
          {t("generationInProgress")}
        </div>
      )}
    </div>
  )
}
